import { Box, Typography } from '@mui/material';
import { notesTypographySx, notesIconsContainerSx } from '../styles/createCampaign';

// Constants
const ICON_BASE_PATH = '/static/images/icons/local-seo';
export const PERSON_ICON = `${ICON_BASE_PATH}/user.svg`;
export const LOCATION_ICON = `${ICON_BASE_PATH}/location.svg`;
export const PHONE_ICON = `${ICON_BASE_PATH}/phone.svg`;

const ICON_SIZE = 16;

// Types
export interface NotesIconsProps {
  notes: string[];
}

// Component
export const NotesIcons = ({ notes }: NotesIconsProps) => {
  const getIconPath = (noteType: string): string | null => {
    switch (noteType) {
      case 'person':
        return PERSON_ICON;
      case 'location':
        return LOCATION_ICON;
      case 'phone':
        return PHONE_ICON;
      default:
        return null;
    }
  };

  const getIconAlt = (noteType: string): string => {
    switch (noteType) {
      case 'person':
        return 'Person';
      case 'location':
        return 'Location';
      case 'phone':
        return 'Phone';
      default:
        return noteType;
    }
  };

  return (
    <Typography component="div" sx={notesTypographySx}>
      <Box sx={notesIconsContainerSx}>
        {notes.map((note) => {
          const iconPath = getIconPath(note);
          if (!iconPath) return null;

          return (
            <Box
              key={note}
              component="img"
              src={process.env.PUBLIC_URL + iconPath}
              alt={getIconAlt(note)}
              width={ICON_SIZE}
              height={ICON_SIZE}
            />
          );
        })}
      </Box>
    </Typography>
  );
};

